import { IconSpriteChevronLeftThick, IconSpriteChevronRightThick } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { configGetLanguage } from 'common/helper/config/get-language';

import { PaginationLinkTemplateInterface } from './template.interface';

export const PaginationLinkTemplate: FunctionalComponent<PaginationLinkTemplateInterface> = (props) => {
  return (
    <a
      className={`pagination__link ${props.className ? props.className : ''}`}
      href={props.link.href}
      onClick={(e): void => props.onClickPage(e, props.link.page)}
    >
      {props.showPrevIcon &&
        (configGetLanguage().isRtl ? <IconSpriteChevronRightThick /> : <IconSpriteChevronLeftThick />)}
      {props.link.title}
      {props.showNextIcon &&
        (configGetLanguage().isRtl ? <IconSpriteChevronLeftThick /> : <IconSpriteChevronRightThick />)}
    </a>
  );
};
